import { Icon, Logo } from 'lidya-common-components';
import React from 'react';
import { useTranslation, Trans } from 'gatsby-plugin-react-i18next';
import './unserved.sme.less';

const UnservedSME = () => {
  const { t } = useTranslation();
  return (
    <div className="o-investors">
      <div className="m-globalContentContainer">
        <div className="m-investors__container">
          <div className="m-investors__banner --padding --gray">
            <span className="m-investors__text">
              {/* <h2 className="m-investors__text__title"><Trans i18nKey="web.investors.europe" /></h2> */}
              <p className="m-investors__text__brand_2 m-investors__text__brand_2_bigger">
                <Trans i18nKey="web.investors.make.investment" />
              </p>
              <p className="m-investors__text__brand m-investors__text__brand_small">
                <Trans i18nKey="web.investors.we.offer" />
              </p>
            </span>
            <span className="m-investors__table">
              <h2 className="a-investors_table__title">
                {t('web.ivestors.invest.table.versus')}
              </h2>

              <div className="Rtable Rtable--2cols Rtable--collapse">
                <div
                  style={{ order: 0 }}
                  className="Rtable-cell Rtable-cell--head -text-left"
                />
                <div style={{ order: 1 }} className="Rtable-cell -text-left">
                  {t('web.ivestors.invest.table.quick.access')}
                </div>
                <div style={{ order: 2 }} className="Rtable-cell -text-left">
                  {t('web.ivestors.invest.table.easy.application')}
                </div>
                <div style={{ order: 3 }} className="Rtable-cell -text-left">
                  {t('web.ivestors.invest.table.competitive.rates')}
                </div>
                <div
                  style={{ order: 4 }}
                  className="Rtable-cell Rtable-cell--foot -text-left"
                >
                  {t('web.ivestors.invest.table.no.collateral')}
                </div>

                <div
                  style={{ order: 0 }}
                  className="Rtable-cell Rtable-cell--head -shadow"
                >
                  <Logo className="a-investors_table__logo" />
                </div>
                <div style={{ order: 1 }} className="Rtable-cell -shadow">
                  <Icon
                    name="valid"
                    className="a-investors__table__icon -big"
                  />
                  <span className="a-investors_table__underText">
                    {t('web.ivestors.invest.table.24decision')}
                  </span>
                </div>
                <div style={{ order: 2 }} className="Rtable-cell -shadow">
                  <Icon
                    name="valid"
                    className="a-investors__table__icon -big"
                  />
                  <span className="a-investors_table__underText">
                    {t('web.ivestors.invest.table.fully.digital')}
                  </span>
                </div>
                <div style={{ order: 3 }} className="Rtable-cell -shadow">
                  <Icon
                    name="valid"
                    className="a-investors__table__icon -big"
                  />
                  <span className="a-investors_table__underText">
                    {t('web.ivestors.invest.table.smart.use')}
                  </span>
                </div>
                <div
                  style={{ order: 4 }}
                  className="Rtable-cell Rtable-cell--foot -shadow"
                >
                  <Icon
                    name="valid"
                    className="a-investors__table__icon -big"
                  />
                  <span className="a-investors_table__underText">
                    {t('web.ivestors.invest.table.no.coll')}
                  </span>
                </div>

                <div
                  style={{ order: 0 }}
                  className="Rtable-cell Rtable-cell--head"
                >
                  {t('web.ivestors.invest.table.banks')}
                </div>
                <div style={{ order: 1 }} className="Rtable-cell">
                  <Icon name="close" className="a-investors__table__icon" />
                </div>
                <div style={{ order: 2 }} className="Rtable-cell">
                  <Icon name="close" className="a-investors__table__icon" />
                </div>
                <div style={{ order: 3 }} className="Rtable-cell">
                  <Icon name="valid" className="a-investors__table__icon" />
                </div>
                <div
                  style={{ order: 4 }}
                  className="Rtable-cell Rtable-cell--foot"
                >
                  <Icon name="close" className="a-investors__table__icon" />
                </div>
                <div
                  style={{ order: 0 }}
                  className="Rtable-cell Rtable-cell--head"
                >
                  {t('web.ivestors.invest.table.alt.lenders')}
                </div>
                <div style={{ order: 1 }} className="Rtable-cell">
                  <Icon name="valid" className="a-investors__table__icon" />
                </div>
                <div style={{ order: 2 }} className="Rtable-cell">
                  <Icon name="valid" className="a-investors__table__icon" />
                </div>
                <div style={{ order: 3 }} className="Rtable-cell">
                  <Icon name="close" className="a-investors__table__icon" />
                </div>
                <div
                  style={{ order: 4 }}
                  className="Rtable-cell Rtable-cell--foot"
                >
                  <Icon name="valid" className="a-investors__table__icon" />
                </div>
              </div>

              {/* <table>
                <colgroup>
                  <col />
                  <col className="m-investors__table__lidyaColumn" />
                  <col />
                  <col />
                </colgroup>
                <thead>
                  <tr>
                    <th> </th>
                    <th>
                      <Logo />
                    </th>
                    <th>{t('web.ivestors.invest.table.banks')}</th>
                    <th>{t('web.ivestors.invest.table.alt.lenders')}</th>
                  </tr>
                </thead>
                <tr>
                  <td>{t('web.ivestors.invest.table.quick.access')}</td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>
                  <td><Icon name="close" className="a-investors__table__icon" /></td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>

                </tr>
                <tr>
                  <td>{t('web.ivestors.invest.table.easy.application')}</td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>
                  <td><Icon name="close" className="a-investors__table__icon" /></td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>

                </tr>
                <tr>
                  <td>{t('web.ivestors.invest.table.competitive.rates')}</td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>
                  <td><Icon name="close" className="a-investors__table__icon" /></td>
                </tr>
                <tr>
                  <td>{t('web.ivestors.invest.table.no.collateral')}</td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>
                  <td><Icon name="close" className="a-investors__table__icon" /></td>
                  <td><Icon name="valid" className="a-investors__table__icon" /></td>
                </tr>
              </table> */}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UnservedSME;

// "web.investors.make.investment":"Make an Investment that’s worth while",
// "web.investors.we.offer": "We are offering individuals and legal entities the possibility of investing in our debt which will be used of onlending in <strong>Poland</strong> and <strong>Czech Republic</strong>. <br> We provide an annual return of <strong>10%</strong>, and are open to commitments of as low as <strong>99,999.00 USD</strong>.",
